import { render, staticRenderFns } from "./evaluationDialog.vue?vue&type=template&id=3524dd8b&scoped=true&"
import script from "./evaluationDialog.vue?vue&type=script&lang=js&"
export * from "./evaluationDialog.vue?vue&type=script&lang=js&"
import style0 from "./evaluationDialog.vue?vue&type=style&index=0&id=3524dd8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3524dd8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
installComponents(component, {VBtn,VCard,VCol,VDialog,VIcon,VItem,VItemGroup})
